import { render, staticRenderFns } from "./Orderhistory.vue?vue&type=template&id=2f79f1bb&"
import script from "./Orderhistory.vue?vue&type=script&lang=js&"
export * from "./Orderhistory.vue?vue&type=script&lang=js&"
import style0 from "./Orderhistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports